export default "__VITE_ASSET__DTZ7pmgb__"